<template>
  <div>
    <div class="alert-list" v-if="alertList.length > 0">
      <vueSeamlessScroll
        v-if="alertList.length > 0"
        :data="alertList"
        :class-option="defaultOption"
        class="seamless-warp"
      >
        <div class="alert-li" v-for="(item, index) in alertList" :key="index">
          <div class="alert-time">
            {{ $Common.dateFormatDateThree(item.alarmTime) }}
          </div>
          <div class="alert-info" @click="check(item)">
            {{ item.alarmContent }}：{{ item.alarmName }}
          </div>
        </div>
      </vueSeamlessScroll>
    </div>
    <div class="alert-no" v-else>
      <img src="@/assets/img/schoolMonitorCenter/no-alert-list.png" alt="" />
      <div class="no-tip">暂无视频报警</div>
      <div class="tip">欸恩智能系统随时保护</div>
      <div class="tip">您的安全～</div>
    </div>
    <div class="alert-detail" v-if="imgUrl != '' && alertDialog">
      <div class="mask" @click="alertDialog = false"></div>
      <div class="alert-content">
        <div class="alert-close" @click="alertDialog = false">关闭</div>
        <div class="alert-title">报警详情图</div>
        <div class="alert-img">
          <img :src="$store.state.config.fileUrl + imgUrl" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  name: "videoAlertList",
  components: {
    vueSeamlessScroll
  },
  props: {
    alertList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      imgUrl: "",
      alertDialog: false
    };
  },
  created() {},
  mounted() {},
  computed: {
    defaultOption() {
      return {
        step: 0.5, //步长 越大滚动速度越快
        limitMoveNum: 9, //启动无缝滚动最小数据量 this.dataList.length
        hoverStop: true, //是否启用鼠标hover控制
        direction: 1, //1 往上 0 往下
        openWatch: true, //开启data实时监听
        singleHeight: 0, //单条数据高度有值hoverStop关闭
        waitTime: 1000 //单步停止等待时间
      };
    }
  },
  watch: {
    alertList: function(val) {
      this.alertList = val;
    }
  },
  methods: {
    check(item) {
      this.imgUrl = item.alarmPicUrl;
      this.alertDialog = true;
      // console.log(item);
      // console.log(this.imgUrl);
    }
  },
  destroyed() {}
};
</script>

<style lang="scss" scoped>
.alert-list {
  margin-top: 12px;
  height: 700px;
  overflow-y: scroll;
  padding-right: 12px;
  .alert-li {
    margin-bottom: 16px;
    &:nth-child(n) {
      .alert-info {
        border-left: 9px solid #ff0000;
      }
    }
    &:nth-child(2n) {
      .alert-info {
        border-left: 9px solid #e7ff00;
      }
    }
    &:nth-child(3n) {
      .alert-info {
        border-left: 9px solid#00ffd4;
      }
    }
  }
  .alert-time {
    margin-bottom: 8px;
    padding-left: 20px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 22px;
  }
  .alert-info {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ced0ff;
    line-height: 20px;
    padding: 6px 30px 6px 12px;
    background: rgba(17, 165, 215, 0.2);
    cursor: pointer;
  }
}
.alert-no {
  width: 100%;
  height: 700px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .no-tip {
    margin-top: 16px;
    margin-bottom: 6px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #e9edff;
    line-height: 22px;
    letter-spacing: 1px;
  }
  .tip {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #e9edff;
    line-height: 20px;
    letter-spacing: 1px;
  }
}
.alert-detail {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2001;
  }
  .alert-content {
    width: 780px;
    height: 650px;
    padding: 40px;
    // 已修改
    background: url("~@/assets/img/hiddenDangerNow/hidden-detail-dialog-bg.png")
      center center no-repeat;
    background-size: 100% 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -390px;
    margin-left: -325px;
    z-index: 2002;
    .alert-close {
      width: 56px;
      height: 24px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #d7deff;
      text-align: center;
      line-height: 25px;
      letter-spacing: 1px;
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
    }
    .alert-title {
      font-size: 30px;
      color: #ffffff;
      padding-bottom: 20px;
    }
    .alert-img {
      width: 700px;
      height: 500px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
